import { ActionTypes } from '../constants/ActionTypes';

export function setProjects(projects) {
  return {
    type: ActionTypes.SET_PROJECTS,
    projects
  };
};

export function setCurrentProject(projectID) {
  return {
    type: ActionTypes.SET_CURRENT_PROJECT,
    projectID
  };
};


// WEBPACK FOOTER //
// ./src/actions/projects.js